import { useTranslation } from 'react-i18next';

export function ConvertURL(path: string) {
    const { t } = useTranslation();
    switch (path) {
        case "/lessons":
            return t('Lessons');
        case "/wordlists":
            return t('Pick a word list');
        case "/learn":
            return t('Learn');
        case "/progress":
            return t('My Progress');
        case "/scenario":
            return t('Scenarios');
        case "/search":
            return t('Search');
        default:
            return '';
    }
}
